"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridSpacing = void 0;
const styles_1 = require("@mui/material/styles");
const useResponsive_1 = __importDefault(require("./useResponsive"));
// Material uses an 8px scaling factor by default
exports.gridSpacing = {
    xs: 2,
    lg: 3, // 24px
};
/**
 * Returns corresponding grid spacing value based on screen width
 * @example <caption>`gridSpacing` will be either 16 or 24 depending on screen size</caption>
 * const gridSpacing = useGridSpacing()
 * */
const useGridSpacing = () => {
    const r = (0, useResponsive_1.default)();
    const materialThemeSpacing = (0, styles_1.useTheme)().spacing;
    return materialThemeSpacing(r(exports.gridSpacing) || 2);
};
exports.default = useGridSpacing;
//# sourceMappingURL=useGridSpacing.js.map